import { render, staticRenderFns } from "./AppRadialMenuItem.vue?vue&type=template&id=542a4bd2&"
import script from "./AppRadialMenuItem.vue?vue&type=script&lang=js&"
export * from "./AppRadialMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./AppRadialMenuItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542a4bd2')) {
      api.createRecord('542a4bd2', component.options)
    } else {
      api.reload('542a4bd2', component.options)
    }
    module.hot.accept("./AppRadialMenuItem.vue?vue&type=template&id=542a4bd2&", function () {
      api.rerender('542a4bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppRadialMenuItem.vue"
export default component.exports